
































































import { Component, Vue } from 'vue-property-decorator';
import superAdminGuard from '@/guards/super-admin-guard';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_appSettings_appSettings } from '@/queries/__generated__/appSettings';
import { UNIT_SEARCH } from '@/queries/Unit';
import { GQL_saveAppSettingsVariables } from '@/queries/__generated__/saveAppSettings';
import UnitClosingDatesInfo from '../../components/Unit/UnitClosingDatesInfo.vue';
import gql from 'graphql-tag';

const APPLICATION_SETTINGS = gql`
  query appSettings {
    appSettings {
      altinnPensionUnits {
        id
        name
      }
    }
  },
`;

const SAVE_APPLICATION_SETTINGS = gql`
  mutation saveAppSettings($appSettings: AppSettingsSave!) {
    saveAppSettings(
      input: { appSettings: $appSettings }
    ) {
      appSettings {
        altinnPensionUnits {
          id
          name
        }
      }
    }
  },
`;



@Component({
  beforeRouteEnter(to, from, next) {
    superAdminGuard(to, from, next).catch(router => {
      router.push({ name: 'Dashboard' });
      router.app.$sMessage.error(router.app.$t('noPermissions'));
    });
  },
  components: {
    UnitClosingDatesInfo,
  },
})
export default class ApplicationSettings extends Vue {
  @SmartQuery(APPLICATION_SETTINGS) private appSettings!: GQL_appSettings_appSettings;

  private UNIT_SEARCH = UNIT_SEARCH;
  private today = this.$dayjs().format('YYYY-MM-DD');

  private save() {
    const variables: GQL_saveAppSettingsVariables = {
      appSettings: {
        altinnPensionUnitIds: this.appSettings.altinnPensionUnits.map(u => u.id),
      },
    };

    this.$apollo.mutate({
      mutation: SAVE_APPLICATION_SETTINGS,
      variables,
      refetchQueries: [ { query: APPLICATION_SETTINGS } ],
    }).then(() => {
      this.$sMessage.success(this.$i18n.t('Message.saveSuccess'));
    });
  }
}
